module.exports = __webpack_public_path__ + "img/matias_penhos.b7a78898.jpg";